import styled from 'styled-components';

const StyledContainer = styled.div<{ $gap?: number }>`
	position: relative;
	display: flex;
	gap: 20px;
`;

const StyledSliderWrapper = styled.div`
	position: relative;
`;

const StyledSliderContainer = styled.div<{ $width: number }>`
	position: relative;
	width: ${(props) => props.$width}px;
	height: 20px;
	display: flex;
	align-items: center;

	> div {
		width: 30px;
		height: 3px;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
		background-color: #ffffff80;
	}

	&::before {
		content: '';
		position: absolute;
		top: 50%;
		width: 100%;
		height: 20px;
		transform: translateY(-50%);
		background-color: rgba(255, 255, 255, 0.02);
		border: 1px solid rgba(255, 255, 255, 0.05);
		border-radius: 5px;
		pointer-events: none;
	}
`;

const StyledSlider = styled.input.attrs({
	type: 'range',
})`
	appearance: none;
	width: 100%;
	margin: 0;
	background: transparent;
	cursor: pointer;
	border-radius: 5px;

	&:focus {
		outline: 0;
	}

	&::-webkit-slider-runnable-track {
		height: 20px;
		margin: 0 5px;
		width: calc(100% - 10px);
	}

	&::-webkit-slider-thumb {
		appearance: none;
		margin-top: 5px;
		width: 10px;
		height: 10px;
		border-radius: 10px;
		background-color: #fff;
		background-clip: content-box;
	}

	&:disabled {
		pointer-events: none;
	}
`;

const StyledSliderBackground = styled.div<{ $center?: boolean }>`
	position: absolute;
	width: ${(props) => (props.$center ? 50 : 100)}%;
	height: 14px;
	pointer-events: none;
	background-color: #2d70da;
`;

const StyledSliderBackgroudWrapper = styled.div`
	position: absolute;
	top: 0;
	width: calc(100% - 6px);
	height: 14px;
	border-radius: 5px;
	overflow: hidden;
	margin-top: 3px;
	margin-left: 3px;
	margin-right: 3px;
`;

const StyledCenterLine = styled.div<{ $width: number }>`
	position: absolute;
	top: 5px;
	left: ${(props) => Math.ceil(props.$width / 2)}px;
	width: 1px;
	height: 10px;
	background-color: rgba(255, 255, 255, 0.25);
	z-index: 3;
`;

const StyledValueInput = styled.input`
	width: 40px;
	height: 20px;
	border-radius: 5px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	color: #ffffff;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	text-align: center;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}

	&:focus {
		outline: none;
	}

	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
`;

export {
	StyledCenterLine,
	StyledContainer,
	StyledSlider,
	StyledSliderBackgroudWrapper,
	StyledSliderBackground,
	StyledSliderContainer,
	StyledSliderWrapper,
	StyledValueInput,
};
